module.exports = __webpack_public_path__ + "static/img/1_0039.2db75a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0039.jpg
// module id = cYRF
// module chunks = 0